import Vue from 'vue'

// 获取今日交付订单列表
const getTodayDeliveryOrders = (params) => {
    
    return Vue.prototype.$http.get('/api/v4/salor/needDeliveryOrders', {
        params: params
    })
}

// 获取已超时的未分配订单列表
const getUnAssignDocerOrders = (params) => {
    
    return Vue.prototype.$http.get('/api/v4/salor/unAssignDocerOrders', {
        params: params
    })
}

// 获取今日交付订单列表
const getNeedPayAndExistDraftDocOrders = (params) => {
    
    return Vue.prototype.$http.get('/api/v4/salor/needPayAndExistDraftDocOrders', {
        params: params
    })
}

export {
    getTodayDeliveryOrders,
    getUnAssignDocerOrders,
    getNeedPayAndExistDraftDocOrders
}


// WEBPACK FOOTER //
// ./src/data/order/salor.js